module.exports = __webpack_public_path__ + "static/modesta-lps-fb8d8e400bee8ab82c9fdf60deaa7d2e.png";